import Vue from 'vue'
import Vuex from 'vuex'
import common from './app/common'
import module from './app/aricent'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: common,
    module: module
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js